<template>
		<div class="card cardptpr mb-4">
			<div class="card-header p-3 pb-0 pt-0">
				<H6>{{this.title}}</H6>
			</div>
			<div class="card-body p-3 pt-0">
				<BarChart :data="this.data" :width="this.width" :height="this.height" :url="this.url" :tooltipaftertitle="this.tooltipaftertitle"/>
			</div>

			<Loader v-if="loading" />

		</div>
</template>

<script>
import BarChart from '@/components/chart/BarChart.js'
import Loader from '@/components/loader/Loader2.vue'

export default{
	props:["data", "title", "width", "height", "url", "tooltipaftertitle", "loading"], //additional: tooltipaftertitle, loading
	components:{
		BarChart,
		Loader
	},
    mounted(){
    },
    methods:{
	}
}

</script>
